module.exports = __webpack_public_path__ + "img/5.247bc9dc.png";